module.exports = __webpack_public_path__ + "img/2add855aa7dc5afc0289b18c6e0982aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_banner.png
// module id = 905
// module chunks = 5